import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

const CREATE_ORDER_COMMMENT = gql`
  mutation createComment($input: CommentInput) {
    createComment(input: $input) {
      status
      message
    }
  }
`

const CREATE_ORDER_LOGBOOK = gql`
  mutation createLogOrder($input: LogOrderInput) {
    createLogOrder(input: $input) {
      status
      message
    }
  }
`

const CreateOrderComment = ({ children, callHistoryType, ...props }) => {
  const refetchQueries = callHistoryType === 'logbook' ? ['getLogByOrderId'] : ['getCommentsbyOrderId']
  const mutation = callHistoryType === 'logbook' ? CREATE_ORDER_LOGBOOK : CREATE_ORDER_COMMMENT

  return (
    <MutationManager mutation={mutation} refetchQueries={refetchQueries} {...props}>
      {({ data, loading, updateFn }) => children({ updateFn, loading, ...props })}
    </MutationManager>
  )
}

CreateOrderComment.propTypes = {
  children: PropTypes.any
}

export default CreateOrderComment
